import React from 'react';
import { string as stringType, shape as shapeType, bool as boolType } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { EXPECTED_DELIVERY_DATE } from '../constants/index';
import { CustomSkeletonLine } from './subcomponents/CustomSkeletonLine';
import useGetPlaceholderHeight from '../hooks/useGetPlaceholderHeight';

const BundleDeliveryDate = ({ product, loading }) => {

  const configDeliveryDate = useConfigService('fs:deliverydate') || null;
  const { deliveryDatePlaceholderHeight } = useGetPlaceholderHeight(product);
  const { getAvailability } = product?.features || {};
  const { deliveryDate } = configDeliveryDate || product?.bundleSpecificationDetails || {};

  if (getAvailability && loading) {
    return <CustomSkeletonLine height={deliveryDatePlaceholderHeight} />;
  }

  if (!deliveryDate || !getAvailability) {
    return null;
  }

  return (
    <div data-component="BundleDeliveryDate">
      <div className="sui-flex">
        <Typography variant="body-lg">Available by&nbsp;</Typography>
        <Typography variant="body-lg" weight="bold">{`${deliveryDate}`}</Typography>
      </div>
      <Typography variant="body-sm">{EXPECTED_DELIVERY_DATE}</Typography>
    </div>
  );
};

BundleDeliveryDate.propTypes = {
  product: shapeType({
    bundleSpecificationDetails: shapeType({
      deliveryDate: stringType
    })
  }).isRequired,
  loading: boolType.isRequired
};

BundleDeliveryDate.displayName = 'BundleDeliveryDate';

export { BundleDeliveryDate };